export const GEO_LOCATION_COOKIE = 'coordLongLat'
export const SHARE_LOCATION = 'share location'
export const PLACEHOLDER_TEXT = 'State, County, City, Zip, Address'
export const MAX_AMOUNT_OF_ADDRESS_RESULTS = 4
export const MAX_AMOUNT_RECENT_SEARCHES = 3
